var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {_defineProperty(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}function _defineProperty(obj, key, value) {key = _toPropertyKey(key);if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}function _toPropertyKey(arg) {var key = _toPrimitive(arg, "string");return typeof key === "symbol" ? key : String(key);}function _toPrimitive(input, hint) {if (typeof input !== "object" || input === null) return input;var prim = input[Symbol.toPrimitive];if (prim !== undefined) {var res = prim.call(input, hint || "default");if (typeof res !== "object") return res;throw new TypeError("@@toPrimitive must return a primitive value.");}return (hint === "string" ? String : Number)(input);}import { Field } from 'react-redux-form';
import { Icon } from "../../UI";
import React from 'react';
import { FormGroup } from "../../Forms";
import { LocalForm } from "../../Forms/Form";
import { Translate, t } from "../../I18N";








const WebMediaResourceForm = ({
  handleSubmit,
  url,
  dispatch,
  hasName = false
}) => {
  const validators = _objectSpread(_objectSpread({},
  hasName && { name: { required: (val) => !!val && val.trim() !== '' } }), {}, {
    url: { required: (val) => !!val && val.trim() !== '' } });


  return /*#__PURE__*/(
    _jsx(LocalForm, {
      onSubmit: handleSubmit,
      getDispatch: dispatch,
      model: "urlForm",
      validators: validators,
      initialState: { url },
      className: !hasName ? 'select-from-link' : '' }, void 0, /*#__PURE__*/

    _jsx(FormGroup, { className: "has-feedback", model: ".url" }, void 0, /*#__PURE__*/
    _jsx(Field, { model: ".url" }, void 0, /*#__PURE__*/
    _jsx("input", {
      type: "text",
      className: "form-control web-attachment-url",
      placeholder: t('System', 'Paste URL here', null, false) }
    )
    )
    ),
    hasName && /*#__PURE__*/
    _jsx(FormGroup, { className: "form-group", model: ".name" }, void 0, /*#__PURE__*/
    _jsx(Field, { model: ".name", className: "field" }, void 0, /*#__PURE__*/
    _jsx("input", {
      type: "text",
      className: "form-control web-attachment-name",
      placeholder: t('System', 'Title', null, false) }
    )
    )
    ), /*#__PURE__*/

    _jsx("button", { type: "submit", className: "btn" }, void 0, /*#__PURE__*/
    _jsx(Icon, { icon: "link" }), "\xA0 ", /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Add from URL")
    )
    ));

};

export { WebMediaResourceForm };